import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AB_API_SENTOO_STATUS } from '../../../app/shared/constants';
import { ApiClientService } from '../../../app/shared/services/api-client.service';

export type PaymentStatus =
  | 'complete'
  | 'landing'
  | 'pending'
  | 'unpaid'
  | 'paying'
  | 'validatePaymentWithToken'
  | 'cancelled'
  | 'expired'
  | 'invalid'
  | 'connection';

export interface StatusResponse {
  numberOfApprovalsRequired: number;
  returnUrl: string;
  beneficiaryName: string;
}

@Injectable({
  providedIn: 'root'
})
export class StatusService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_SENTOO_STATUS);
  }

  getStatus(country: string, sentooTransaction: string): Observable<any> {
    const params = new HttpParams()
      .set('country', country)
      .set('sentoo-transaction', sentooTransaction);
    return this.get(params);
  }
}
